<a
  *ngIf="isLink(item) && !isFunction(item.route)"
  [fragment]="item.fragment"
  [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }"
  [routerLink]="item.route"
  class="item"
  fxLayout="row"
  matRipple
  routerLinkActive="active"
>
  <mat-icon
    *ngIf="level === 0"
    [icIcon]="item.icon"
    class="item-icon"
    fxFlex="none"
  ></mat-icon>
  <span class="item-label" fxFlex="auto">{{ 'navItems.' + item.label | translate }} </span>
  <span
    *ngIf="item.badge"
    [ngClass]="[item.badge.bgClass, item.badge.textClass]"
    class="item-badge"
    fxFlex="none"
    >{{ item.badge.value }}</span
  >
</a>

<ng-container *ngIf="isSubheading(item)">
  <div class="subheading">{{ item.label }}</div>
  <vex-sidenav-item
    *ngFor="let subItem of item.children"
    [item]="subItem"
    [level]="0"
  ></vex-sidenav-item>
</ng-container>
